<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <div
            class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show"
            role="alert"
          >
            <div class="m-alert__icon">
              <i class="flaticon-exclamation-1" />
              <span />
            </div>
            <div class="m-alert__text">
              {{ $t('support.infoMsg') }}
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-8">
              <div class="m-portlet m-portlet--rounded">
                <formSupport
                  :contact="contact"
                  :send-contact-form="sendContactForm"
                />
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-4 col-lg-5 col-xl-4">
              <div class="m-portlet m-portlet--rounded">
                <infoSupport />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->
  </div>
</template>

<script>

import { getUser, onBeforeOpenSwal } from '../../../functions.ts';
import { clientapi } from '../../../api-clients/client-api.js';

import AppHeader from '../common/Header.vue';
import AppFooter from '../common/Footer.vue';
import LeftMenu from '../common/menus/LeftMenu.vue';
import formSupport from './Form.vue';
import infoSupport from './Info.vue';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
        formSupport,
        infoSupport,
    },
    data() {
        return {
            contact: {
                subject: null,
                body: null,
            },
            user: {},
        };
    },
    mounted() {
        this.user = getUser();
    },
    methods: {
        async sendContactForm() {
            if ( !this.contact.subject || !this.contact.body ) {
                swal( {
                    title: this.$t( 'error.MissingFields' ),
                    text: this.$t( 'error.PleaseFillUpAllFields' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            let params = {
                'subject': this.contact.subject,
                'body': this.contact.body,
            };

            let response = await clientapi.post( '/contact', params );

            if ( response.status !== 200 ) {
                let errorCode = response.data.code;
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.server.' + errorCode ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            swal( {
                title: this.$t( 'success.formSubmitedOK' ),
                text: response.data.message,
                type: 'success',
                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } );

            this.contact.body = '';
            this.contact.subject = '';
        },
    },
};
</script>
